export const isUsingSafari = () => {
  const agent = navigator.userAgent

  const safariAgent = agent.indexOf("Safari") > -1;
  const chromeAgent = agent.indexOf("Chrome") > -1;

  return safariAgent && !chromeAgent
}
